import React, { ReactNode } from 'react'
import { DatePickerPeriod } from 'ui/molecules/pickers/DatePicker/DatePickerPeriod'
import { endOfSettlementToday, pickerSelectionToDayRange } from './SettlementExportButton.helper'
import type { DayRange } from './SettlementExportButton.types'

type SettlementDayRangePickerProps = {
  range: DayRange
  onRangeChange: (range: DayRange) => void
  onValidityChange: (isInvalid: boolean) => void
}

/**
 * Whole days only: an export ending at a time of day rather than at midnight is accepted by the
 * backend and silently loses the hours after it.
 */
export function SettlementDayRangePicker({
  range,
  onRangeChange,
  onValidityChange,
}: SettlementDayRangePickerProps): ReactNode {
  function handleSelect(startTime: ISODateTime | null | undefined, endTime: ISODateTime | null | undefined): void {
    const selectedRange = pickerSelectionToDayRange(startTime, endTime)
    if (selectedRange) onRangeChange(selectedRange)
  }

  return (
    <DatePickerPeriod
      granularity="day"
      maxDate={endOfSettlementToday()}
      startDate={range.firstDay}
      endDate={range.lastDay}
      onSelect={handleSelect}
      onError={onValidityChange}
    />
  )
}
